/**
 * Ingebouwde browsers van sociale apps (Instagram, Facebook, TikTok) gaan
 * slecht om met bestandskeuze en uploads; in Sentry PRINTEN-EU-1S liep een
 * klant in de Instagram-app drie keer vast op dezelfde foto. Herken ze, zodat
 * de uploadstap kan voorstellen de pagina in de gewone browser te openen.
 */
export type InAppBrowser = 'instagram' | 'facebook' | 'tiktok';

export function detectInAppBrowser(userAgent: string | null | undefined): InAppBrowser | null {
  const ua = String(userAgent || '');
  if (/Instagram/i.test(ua)) return 'instagram';
  if (/FBAN|FBAV|FB_IAB|FBIOS/i.test(ua)) return 'facebook';
  if (/BytedanceWebview|musical_ly|TikTok/i.test(ua)) return 'tiktok';
  return null;
}

const APP_NAME: Record<InAppBrowser, string> = { instagram: 'Instagram', facebook: 'Facebook', tiktok: 'TikTok' };

export function inAppBrowserNotice(locale: string, app: InAppBrowser) {
  const name = APP_NAME[app];
  if (locale === 'de') return `Sie sind in der ${name}-App. Klappt das Hochladen nicht, öffnen Sie die Seite über das Menü (•••) im normalen Browser.`;
  if (locale === 'en') return `You are in the ${name} app. If uploading does not work, open this page in your normal browser via the menu (•••).`;
  if (locale === 'fr') return `Vous êtes dans l'application ${name}. Si le téléversement ne fonctionne pas, ouvrez cette page dans votre navigateur via le menu (•••).`;
  return `Je zit in de ${name}-app. Lukt uploaden niet, open de pagina dan via het menu (•••) in je gewone browser.`;
}
